import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { invokeGetService, invokePostService, setReRender, handleSnackBar, toggleRightDrawer, setInnerScreenRender, setFocusElement } from "../../../store/global/actions";
import FormEditor from '../../atoms/jsonFormEditor/FormEditor';
import LoaderWithProgress from '../../atoms/loader/LoaderWithProgress';
import { getRightDrawerStatus } from '../../../store/global/selectors';


const options = {
    form_name_root: "testsuite",
    show_errors: "never"
}

export default function EditTestsuite({  id, onCompletion, onClose }) {
    
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false)
    const [schemaValues, setSchemaValues] = useState({})
    const [isUpdating, setIsUpdating] = useState(false);

    const rightDrawerStatus = useSelector(getRightDrawerStatus);


    useEffect(() => {
        loadTestsuite()
    }, [id]);


    const loadTestsuite = () => {
        setLoading(true)
        dispatch(invokeGetService('getSimulationTestsuite', [id]))
            .then((response) => {
                if(response.status){
                    setSchemaValues(mappingSchema(response.data?.testsuite));
                    setLoading(false);
                }else{
                }
            })
    }

    const mappingSchema = (selectedTestsuite) => {
        let schemaValues;

        if (selectedTestsuite !== undefined && selectedTestsuite !== null) {
            schemaValues = { name: selectedTestsuite.name, description: selectedTestsuite.description ? selectedTestsuite.description : "" };
        }
        return schemaValues
    }

    let schema = {
        type: 'object',
        required: ['name', 'description'],
        options: {
            layout: 'grid',
            disable_properties: 'false'
        },
        properties: {
            name: {
                title: 'Name',
                type: 'string',
                options: {
                    layout: 'grid',
                    grid_columns: 12
                },
            },
            description: {
                title: 'Description',
                type: 'string',
                format: 'textarea',
                options: {
                    layout: 'grid',
                    grid_columns: 12
                },
            },
        }
    }

    const validation = (schema, value, path) => {
        var errors = [];
        return errors;
    };

    const customValidation = (data) => {
        let errors = [];
        if (data.name == "") {
            errors.push({
                path: "testsuite.name",
                property: 'format',
                message: "Please enter name"
            })
        }

        // if (data.description && validateNonAsciiChars(data.description) !== true){
        //     errors.push({
        //         path: "testsuite.description",
        //         property: 'format',
        //         message: validateNonAsciiChars(data.description)
        //     })
        // }
        return errors;
    }


    const onUpdate = (data) => {
        setIsUpdating(true);

        const payload = {
            name: data.name,
            description: data.description
        }

        dispatch(invokePostService('updateSimulationTestsuite', {testsuite: payload}, [id])).then(response => {
            setIsUpdating(false);
            if (response.status == true) {
                dispatch(setInnerScreenRender());
                dispatch(toggleRightDrawer());
                dispatch(setFocusElement({}));
                dispatch(setReRender());
                onCompletion('edit', response.message);
            } else {
                if (response?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                    dispatch(handleSnackBar({ open: true, message: response.errors[0].message, severity: 'error' }))
                }
                if (response.code === 255) {
                    if (rightDrawerStatus == true) dispatch(toggleRightDrawer());
                }
            }
        });
    }

    return (
        <>
            {loading && <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: '35vh' }} />}
            {!loading && <>
                <FormEditor options={options} schema={schema} onSave={onUpdate} onClose={onClose} schemaValues={schemaValues} validation={validation} customValidation={customValidation} key={id} isUpdating={isUpdating} action={'edit'} />
            </>}
        </>

    )


}

